import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../lib/cn.js";
let idCounter = 0;
function useStableId(prefix) {
    const idRef = React.useRef(undefined);
    if (!idRef.current)
        idRef.current = `${prefix}-${(idCounter += 1)}`;
    return idRef.current;
}
/**
 * The shared `<select>` primitive — every feature page until now hand-
 * rolled its own copy of this exact markup/class list (events, schedule
 * items, displays, remote control, backup, settings all had an inline
 * native select with identical Tailwind classes). Same labeling/error
 * discipline as `TextField` (§7.17): a visible label, inline error via
 * `aria-describedby`, never a tooltip-only error.
 */
export function Select({ label, error, hint, id, className, required, options, value, onChange, placeholder, ...props }) {
    const generatedId = useStableId("select");
    const fieldId = id ?? generatedId;
    const errorId = `${fieldId}-error`;
    const hintId = `${fieldId}-hint`;
    const hasMatch = options.some((option) => option.value === value);
    const selectEl = (_jsxs("select", { id: fieldId, required: required, "aria-required": required || undefined, "aria-invalid": Boolean(error) || undefined, "aria-describedby": error ? errorId : hint ? hintId : undefined, value: value, onChange: (event) => onChange(event.target.value), className: cn("h-9 rounded-md border bg-surface px-3 text-body text-fg-primary outline-none transition-colors duration-fast", "focus-visible:ring-2 focus-visible:ring-brand-primary", error ? "border-status-critical" : "border-line", className), ...props, children: [placeholder && !hasMatch ? (_jsx("option", { value: "", disabled: true, children: placeholder })) : null, options.map((option) => (_jsx("option", { value: option.value, disabled: option.disabled, children: option.label }, option.value)))] }));
    if (!label)
        return selectEl;
    return (_jsxs("div", { className: "flex flex-col gap-1.5", children: [_jsxs("label", { htmlFor: fieldId, className: "text-body text-fg-secondary", children: [label, required ? _jsx("span", { className: "text-status-critical", children: " *" }) : null] }), selectEl, error ? (_jsx("p", { id: errorId, className: "text-caption text-status-critical", children: error })) : hint ? (_jsx("p", { id: hintId, className: "text-caption text-fg-tertiary", children: hint })) : null] }));
}
//# sourceMappingURL=select.js.map